import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=88fd1cd8&scoped=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd1cd8",
  null
  
)

export default component.exports